// Guest
export const FETCH_COMPLAINTS_REQUEST = 'FETCH_COMPLAINTS_REQUEST';
export const FETCH_COMPLAINTS_SUCCESS = 'FETCH_COMPLAINTS_SUCCESS';
export const FETCH_COMPLAINTS_FAILURE = 'FETCH_COMPLAINTS_FAILURE';

export const FETCH_COMPLAINT_REQUEST = 'FETCH_COMPLAINT_REQUEST';
export const FETCH_COMPLAINT_SUCCESS = 'FETCH_COMPLAINT_SUCCESS';
export const FETCH_COMPLAINT_FAILURE = 'FETCH_COMPLAINT_FAILURE';

export const CREATE_COMPLAINT_REQUEST = 'CREATE_COMPLAINT_REQUEST';
export const CREATE_COMPLAINT_SUCCESS = 'CREATE_COMPLAINT_SUCCESS';
export const CREATE_COMPLAINT_FAILURE = 'CREATE_COMPLAINT_FAILURE';

export const UPDATE_COMPLAINT_REQUEST = 'UPDATE_COMPLAINT_REQUEST';
export const UPDATE_COMPLAINT_SUCCESS = 'UPDATE_COMPLAINT_SUCCESS';
export const UPDATE_COMPLAINT_FAILURE = 'UPDATE_COMPLAINT_FAILURE';

export const WITHDRAW_COMPLAINT_REQUEST = 'WITHDRAW_COMPLAINT_REQUEST';
export const WITHDRAW_COMPLAINT_SUCCESS = 'WITHDRAW_COMPLAINT_SUCCESS';
export const WITHDRAW_COMPLAINT_FAILURE = 'WITHDRAW_COMPLAINT_FAILURE';

export const RESPOND_COMPLAINT_REQUEST = 'RESPOND_COMPLAINT_REQUEST';
export const RESPOND_COMPLAINT_SUCCESS = 'RESPOND_COMPLAINT_SUCCESS';
export const RESPOND_COMPLAINT_FAILURE = 'RESPOND_COMPLAINT_FAILURE';

export const UPLOAD_COMPLAINT_IMAGE_REQUEST = 'UPLOAD_COMPLAINT_IMAGE_REQUEST';
export const UPLOAD_COMPLAINT_IMAGE_SUCCESS = 'UPLOAD_COMPLAINT_IMAGE_SUCCESS';
export const UPLOAD_COMPLAINT_IMAGE_FAILURE = 'UPLOAD_COMPLAINT_IMAGE_FAILURE';

// Host
export const FETCH_HOST_COMPLAINTS_REQUEST = 'FETCH_HOST_COMPLAINTS_REQUEST';
export const FETCH_HOST_COMPLAINTS_SUCCESS = 'FETCH_HOST_COMPLAINTS_SUCCESS';
export const FETCH_HOST_COMPLAINTS_FAILURE = 'FETCH_HOST_COMPLAINTS_FAILURE';

export const FETCH_HOST_COMPLAINT_REQUEST = 'FETCH_HOST_COMPLAINT_REQUEST';
export const FETCH_HOST_COMPLAINT_SUCCESS = 'FETCH_HOST_COMPLAINT_SUCCESS';
export const FETCH_HOST_COMPLAINT_FAILURE = 'FETCH_HOST_COMPLAINT_FAILURE';

export const HOST_RESPOND_COMPLAINT_REQUEST = 'HOST_RESPOND_COMPLAINT_REQUEST';
export const HOST_RESPOND_COMPLAINT_SUCCESS = 'HOST_RESPOND_COMPLAINT_SUCCESS';
export const HOST_RESPOND_COMPLAINT_FAILURE = 'HOST_RESPOND_COMPLAINT_FAILURE';

// Shared
export const COMPLAINT_CONFLICT = 'COMPLAINT_CONFLICT';
export const COMPLAINT_IMAGE_WARNING = 'COMPLAINT_IMAGE_WARNING';
export const COMPLAINTS_RESET = 'COMPLAINTS_RESET';
